import { __makeTemplateObject } from "tslib";
import styled, { css } from 'styled-components';
import { colors } from '@keen.io/colors';
var FakeInput = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 42px;\n  border-bottom: solid 1px ", "\n  box-sizing: border-box;\n\n  ", "\n"], ["\n  height: 42px;\n  border-bottom: solid 1px ", "\n  box-sizing: border-box;\n\n  ",
    "\n"])), colors.blue['400'], function (props) {
    return props.hasError && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border-bottom: solid 2px ", ";\n    "], ["\n      border-bottom: solid 2px ", ";\n    "])), colors.orange['300']);
});
export default FakeInput;
var templateObject_1, templateObject_2;
